export enum EClickPosition {
  /** Common begins */
  TopBarLogo = 'top_bar_logo',
  TopBarDownload = 'top_bar_download',
  BottomButton = 'bottom_button',

  RelatedPostTitle = 'related_post_title',
  RelatedPost = 'related_post',
  RelatedPostSeeMore = 'related_post_see_more',
  /** Common ends */

  /** Article begins */
  MainHashtag = 'main_hashtag',
  MainContentPOI = 'main_content_poi',
  MainContentMentionedUser = 'main_content_mentioned_user',
  MainContentReadmore = 'main_content_readmore',
  MainInnerLink = 'main_inner_link',
  MainPOI = 'main_poi',
  MainAuthor = 'main_author',
  MainSearchAnchor = 'main_search_anchor',
  MainFollowButton = 'main_follow_button',
  MainVideoSeeMore = 'main_video_see_more',
  MainVideoInterception = 'main_video_interception',
  MainGalleryImage = 'main_gallery_image',
  MainGalleryInterception = 'main_gallery_interception',
  MainFavoriteIcon = 'main_favorite_icon',
  MainLikeIcon = 'main_like_icon',
  MainCommentIcon = 'main_comment_icon',
  MainShareIcon = 'main_share_icon',

  EndRecommend = 'end_recommend',
  EndSeeMore = 'end_see_more',

  CommentAuthor = 'comment_author',
  CommentReply = 'comment_reply',
  CommentDigg = 'comment_digg',
  CommentImage = 'comment_image',
  CommentMentionedUser = 'comment_mentioned_user',
  CommentSeeMore = 'comment_see_more',
  CommentReplySeeMore = 'comment_reply_see_more',
  /** Article ends */

  /** User begins **/
  UserFollowing = 'user_following',
  UserFans = 'user_fans',
  UserLikes = 'user_likes',
  AuthorFollowButton = 'author_follow_button',
  AuthorPrivateLetter = 'author_private_letter',
  AuthorTriangularArrow = 'author_triangular_arrow',
  AuthorPost = 'author_post',

  RelatedUser = 'related_user',
  /** User ends */

  /** POI begins */
  RelatedAddress = 'related_address',
  RelatedPhone = 'related_phone',
  /** POI ends */
}
